export default "__VITE_ASSET__CVFDosfa__"